export default __webpack_public_path__ + "static/media/card_dexpro5.9f8789f1.png";